import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { occasionOption } from "Apis/occasion";

export const ReserveDateContext = createContext();

export const ReserveDateContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [occasionListData, setOccasionListData] = useState([]);

  const getOccasionListApi = async () => {
    const data = {
      is_admin: true,
    };
    let response = await occasionOption(data);

    if (response?.status === 200) {
      const sortedData = response.data.data.rows
        ?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label));

      setOccasionListData(sortedData);
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <ReserveDateContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        occasionListData,
        setOccasionListData,
        getOccasionListApi,
      }}
    >
      {children}
    </ReserveDateContext.Provider>
  );
};

export default ReserveDateContextProvider;
ReserveDateContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
